import { useNavigate, useLocation } from '@usas/ui-web/wrappers/ReactRouterDom';
import NavLinks from './NavLinks';
import useRecordsAdminData from '../../state/recordsAdmin/UseRecordsData';

import useSelectOrgUnitData from '@usas/ui-web/state/selectOrgUnit/UseSelectOrgUnitData';

const useManageTimeStandardsContextView = () => {
  const { selectOrgUnitState, resetSelectOrgUnitState } = useSelectOrgUnitData();
  const navigate = useNavigate();
  const location = useLocation();
  const { recordsState } = useRecordsAdminData();

  const onClicked = (e) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    navigate(NavLinks.RECORDS_ADMIN);
  }

  return {
    location,
    recordsState,
    selectOrgUnitState,
    backToLabel: 'Back to Records Admin Search',
    onClicked
  };
};

export default useManageTimeStandardsContextView;